import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { UsersDataRequestPayloadTypes } from '../models/user-management';

const UserManagementService = {
  fetchUserList: async (payload?: UsersDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.USER_SERVICE_BASE_URL + '/users', { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addNewUser: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.USER_SERVICE_BASE_URL + '/users', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateUser: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.put(apiPath.USER_SERVICE_BASE_URL + '/users/' + payload.id, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deleteUsers: async (payload: any) => {
    try {
      const reqParams = payload.map((item: any) => {
        return item;
      });

      const apiResponse = await axiosClient.delete(apiPath.USER_SERVICE_BASE_URL + '/users', {
        data: { user_ids: [...reqParams] },
      });
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchUserAccessList: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.USER_SERVICE_BASE_URL + '/users/' + payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default UserManagementService;
